module.exports = __webpack_public_path__ + "static/ice-left-5b76fbac2ac11b10e3ca606e80e7965b.png";